import React from "react";
import Moment from "moment";

// Shared card for the "Assigned" and "Completed" learning game lists on the
// Student Dashboard and the Learning Progress page.

// Category name -> icon + accent theme. Matched by keyword so new
// categories like "Shape Sorting" still pick up a sensible look.
const CATEGORY_THEMES = [
  { match: ["brain", "puzzle", "logic"], icon: "extension", theme: "violet" },
  { match: ["number", "math", "count"], icon: "calculate", theme: "amber" },
  { match: ["sound", "music", "audio"], icon: "music_note", theme: "pink" },
  { match: ["color", "colour", "paint"], icon: "palette", theme: "orange" },
  { match: ["shape"], icon: "category", theme: "teal" },
  { match: ["letter", "word", "alphabet", "read"], icon: "abc", theme: "blue" },
];

const getCategoryTheme = (categoryName) => {
  const name = String(categoryName || "").toLowerCase();
  return (
    CATEGORY_THEMES.find((entry) => entry.match.some((keyword) => name.includes(keyword))) || {
      icon: "sports_esports",
      theme: "green",
    }
  );
};

export default function LearningGameCard({ game, fallbackTitle, completed = false, level, score, onPlay }) {
  const title = game?.game_name?.name || fallbackTitle || "Learning game";
  const category = game?.game_name?.category?.name;
  const { icon, theme } = getCategoryTheme(category);
  const hasLevel = level !== null && level !== undefined;
  const hasScore = score !== null && score !== undefined;

  return (
    <div className={`lgc-card lgc-theme-${theme}${completed ? " lgc-card-completed" : ""}`}>
      <div className="lgc-icon">
        <i className="material-symbols-outlined">{icon}</i>
        {completed ? (
          <span className="lgc-check" aria-hidden="true">
            <i className="material-symbols-outlined">check</i>
          </span>
        ) : null}
      </div>

      <div className="lgc-body">
        <div className="lgc-title" title={title}>{title}</div>
        <div className="lgc-meta">
          <span className="lgc-category">{category || "General"}</span>
          {hasLevel ? <span className="lgc-stat">Lv {level}</span> : null}
          {hasScore ? <span className="lgc-stat">★ {score}</span> : null}
        </div>
        {completed && game?.created_at ? (
          <div className="lgc-date">
            <i className="material-symbols-outlined">event_available</i>
            Completed {Moment(game.created_at).format("MMM D, YYYY")}
          </div>
        ) : null}
      </div>

      <button
        type="button"
        className={`lgc-play${completed ? " lgc-play-again" : ""}`}
        onClick={() => onPlay(game)}
        aria-label={`${completed ? "Play again" : "Play"}: ${title}`}
      >
        <i className="material-symbols-outlined">{completed ? "replay" : "play_arrow"}</i>
        <span>{completed ? "Replay" : "Play"}</span>
      </button>
    </div>
  );
}
